const funcion = {
  IniciarSesion: 'Forseti/ValidaYObtenPermisos'
}

export default funcion;



//////////////////
// WEBPACK FOOTER
// ./static/js/api/forseti/funcion/funcion.js
// module id = null
// module chunks = 